"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("@/views/member/level/config");
var _member = require("@/api/member");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'editLevel',
  props: {
    editDialogConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    level: {
      type: Number,
      default: function _default() {
        return 1;
      }
    }
  },
  data: function data() {
    return {
      tableColumns: _config.couponTableColumns,
      tableData: {
        data: []
      },
      form: this.editDialogConfig.data,
      rules: {
        name: [{
          required: true,
          message: '请输入等级名称',
          trigger: 'blur'
        }, {
          maxlength: 10,
          message: '等级名称最多10个字符',
          trigger: 'blur'
        }],
        thresholdAmount: [{
          required: true,
          message: '请输入升级金额',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '升级金额必须大于0',
          trigger: 'blur'
        }],
        benefitsList: [{
          required: true,
          message: '请至少选择一个等级权益',
          trigger: 'change',
          type: 'array'
        }]
      },
      benefitOptions: [],
      hasGiftBenefit: false,
      // 判断是否有名称包含"入会/升级有礼"的权益
      giftBenefitId: 0 //入会升级有礼的id
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.getBenefits();
    this.getInfo();
    setTimeout(function () {
      _this.changeBenefits();
    }, 100);
  },
  methods: {
    getInfo: function getInfo() {
      this.form.benefitsList = this.form.benefits ? this.form.benefits.split(',').map(Number) : [];
      this.tableData.data = this.editDialogConfig.data.couponList ? this.editDialogConfig.data.couponList : [];
    },
    handleClose: function handleClose() {
      this.$emit('update-close');
    },
    getBenefits: function () {
      var _getBenefits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var giftBenefit;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _member.memberBenefitsListApi)();
            case 1:
              this.benefitOptions = _context.v;
              giftBenefit = this.benefitOptions.find(function (item) {
                return item.name.includes('入会/升级有礼');
              });
              if (giftBenefit) {
                this.giftBenefitId = giftBenefit.id;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getBenefits() {
        return _getBenefits.apply(this, arguments);
      }
      return getBenefits;
    }(),
    changeBenefits: function changeBenefits() {
      // 获取所有选中的权益ID
      var selectedBenefitIds = this.form.benefitsList || [];
      // 判断selectedBenefitIds中是否包含this.giftBenefitId的值
      this.hasGiftBenefit = selectedBenefitIds.includes(this.giftBenefitId);
    },
    // 根据权益ID获取权益信息
    getBenefitById: function getBenefitById(benefitId) {
      return this.benefitOptions.find(function (item) {
        return item.id == benefitId;
      });
    },
    // 保存表单
    saveForm: function saveForm() {
      var _this2 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var formData;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!valid) {
                  _context2.n = 4;
                  break;
                }
                // 处理表单数据
                formData = _objectSpread(_objectSpread({}, _this2.form), {}, {
                  level: _this2.level,
                  // 将权益数组转换为字符串
                  benefits: _this2.form.benefitsList.join(','),
                  // 将优惠券对象数组转换为优惠券ID数组
                  couponIds: _this2.tableData.data.map(function (item) {
                    return item.id;
                  }).join(',')
                });
                if (_this2.form.id) {
                  _context2.n = 2;
                  break;
                }
                _context2.n = 1;
                return (0, _member.memberLevelAddApi)(formData);
              case 1:
                _context2.n = 3;
                break;
              case 2:
                _context2.n = 3;
                return (0, _member.memberLevelUpdateApi)(formData);
              case 3:
                _this2.$message.success('保存成功');
                _this2.editDialogConfig.visible = false;
                // 通知父组件刷新列表
                _this2.$emit('update-success');
                _context2.n = 5;
                break;
              case 4:
                return _context2.a(2, false);
              case 5:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 取消表单
    cancelForm: function cancelForm() {
      this.editDialogConfig.visible = false;
    },
    // 添加优惠券
    addCoupon: function addCoupon() {
      var _this3 = this;
      this.$modalCoupon('wu', this.keyNum += 1, this.tableData.data, function (row) {
        _this3.tableData.data = row;
      }, this.userIds, 'member');
    },
    // 删除优惠券
    removeCoupon: function removeCoupon(index) {
      this.form.couponIds.splice(index, 1);
    }
  }
};